import * as marietta3d from '..';
import { Geometry } from './utils';
import * as marietta from '../../marietta';

export default class AutoArea {
    private autoBase: marietta3d.AutoGen.AutoBase;

    // private Geom: marietta3d.AutoGen.utils.Geometry;

    /*------------------------------------------------------
    * constructor
    */
    constructor(base: marietta3d.AutoGen.AutoBase) {
      this.autoBase = base;
      // this.Geom = new marietta3d.AutoGen.utils.Geometry();
    }

    /*------------------------------------------------------
    * 部屋結合
    *
    */
    public MargeRoom(flr: number, idx1: string, idx2: string): marietta3d.AutoGen.utils.RoomPointArray {
      const source = [];
      const result = [];
      const resultHole = [];
      const plg1 = new marietta3d.AutoGen.utils.RoomPointArray();
      const plg2 = new marietta3d.AutoGen.utils.RoomPointArray();
      for (let i = 0; i < this.autoBase.HeyaList[flr - 1].length; i += 1) {
        const pheya = this.autoBase.HeyaList[flr - 1][i];
        if (pheya.guid === idx1) {
          plg1.CopyFrom(pheya.points);
        }
        if (pheya.guid === idx2) {
          plg2.CopyFrom(pheya.points);
        }
      }
      if ((plg1.length > 0) && (plg2.length > 0)) {
        const stat = plg1.IsIncludePolygon(plg2);
        if (stat === marietta3d.AutoGen.utils.RC_INCLP.AWAY) {
          // ２つの部屋は離れている
          return null;
        }
        source.push(plg1);
        source.push(plg2);
        Geometry.MargePolygon(source, result, resultHole); // 結合処理
        const gai = new marietta3d.AutoGen.utils.RoomPointArray();
        if (result.length > 0) {
          gai.CopyFrom(result[0]);
        }
        return gai;
      }
      // 部屋が見つからない
      return null;
    }

    /*------------------------------------------------------
    * 建物情報
    *
    */
    public AGPlanInfo() {
      for (let flr = 1; flr <= 3; flr += 1) {
        this.Yukamenseki(flr);
        this.Koujimenseki(flr);
      }
      this.RoomCount();
      this.Maguchi();
    }

    /*------------------------------------------------------
    * 指定階の床面積
    *
    */
    private Yukamenseki(flr: number) {
      const source = [];
      const result = [];
      const resultHole = [];
      for (let i = 0; i < this.autoBase.HeyaList[flr - 1].length; i += 1) {
        const pheya = this.autoBase.HeyaList[flr - 1][i];
        // if (pheya.IsPorch()) continue;
        // if (pheya.IsBalcony()) continue;
        /* if (pheya.IsGlayching()) continue; */
        if ((!pheya.IsPorch()) && (!pheya.IsBalcony())) {
          const plg = new marietta3d.AutoGen.utils.RoomPointArray();
          plg.CopyFrom(pheya.points);
          source.push(plg);
        }
      }
      Geometry.MargePolygon(source, result, resultHole);
      let area = 0.0;
      for (let j = 0; j < result.length; j += 1) {
        const gai = result[j];
        area += gai.GetPolyArea();
      }
      let wp = this.autoBase.scaleObj.GetModulePitch();
      wp *= wp;
      let wMod = this.autoBase.scaleObj.GetModule();
      wMod *= wMod;
      this.autoBase.yukaMenseki[flr] = (area / wp) * wMod * 0.001 * 0.001;
    }

    /*------------------------------------------------------
    * 指定階の工事面積
    *
    */
    private Koujimenseki(flr: number) {
      const source = [];
      const result = [];
      const resultHole = [];
      for (let i = 0; i < this.autoBase.HeyaList[flr - 1].length; i += 1) {
        const pheya = this.autoBase.HeyaList[flr - 1][i];
        // if (pheya.IsPorch()) continue;
        /* if (pheya.IsGlayching()) continue; */
        if (!pheya.IsPorch()) {
          const plg = new marietta3d.AutoGen.utils.RoomPointArray();
          plg.CopyFrom(pheya.points);
          source.push(plg);
        }
      }

      Geometry.MargePolygon(source, result, resultHole);
      let area = 0.0;
      for (let j = 0; j < result.length; j += 1) {
        const gai = result[j];
        area += gai.GetPolyArea();
      }
      let wp = this.autoBase.scaleObj.GetModulePitch();
      wp *= wp;
      let wMod = this.autoBase.scaleObj.GetModule();
      wMod *= wMod;
      this.autoBase.koujiMenseki[flr] = (area / wp) * wMod * 0.001 * 0.001;
    }

    /*------------------------------------------------------
    * 部屋数
    *
    */
    private RoomCount() {
      let cnt = 0;
      for (let i = 0; i < this.autoBase.HeyaList.length; i += 1) {
        for (let j = 0; j < this.autoBase.HeyaList[i].length; j += 1) {
          const pheya = this.autoBase.HeyaList[i][j];
          if (pheya.IsFloring() || pheya.IsWasitu() || pheya.IsStudy()) {
            cnt += 1;
          }
        }
      }
      this.autoBase.roomCount = cnt;
    }

    /*------------------------------------------------------
    * １階外周
    *
    */
    private FirstFloor(): marietta3d.AutoGen.utils.RoomPointArray {
      const source = [];
      const result = [];
      const resultHole = [];
      for (let i = 0; i < this.autoBase.HeyaList[0].length; i += 1) {
        const pheya = this.autoBase.HeyaList[0][i];
        if (pheya.IsPorch() === false) {
          /* ポーチ以外の部屋 */
          const plg = new marietta3d.AutoGen.utils.RoomPointArray();
          plg.CopyFrom(pheya.points);
          source.push(plg);
        }
      }
      Geometry.MargePolygon(source, result, resultHole);
      const gai = new marietta3d.AutoGen.utils.RoomPointArray();
      if (result.length > 0) {
        gai.CopyFrom(result[0]);
      }
      return gai;
    }

    /*------------------------------------------------------
    * １階の玄関
    *
    */
    private GetEntrance(): marietta3d.AutoGen.object.AutoObjRoom {
      for (let i = 0; i < this.autoBase.HeyaList[0].length; i += 1) {
        const pheya = this.autoBase.HeyaList[0][i];
        if (pheya.IsEntrance() === true) {
          return pheya;
        }
      }
      return null;
    }

    /*------------------------------------------------------
    * １階のポーチ
    *
    */
    /* private GetPorch(): marietta3d.AutoGen.object.AutoObjRoom {
      for (let i = 0; i < this.autoBase.HeyaList[0].length; i += 1) {
        const pheya = this.autoBase.HeyaList[0][i];
        if (pheya.IsPorch() === true) {
          return pheya;
        }
      }
      return null;
    }
 */
    /*------------------------------------------------------
    * 間口奥行
    *
    */
    private Maguchi() {
      const gai = this.FirstFloor(); /* １階外周 */
      const min = new marietta.core.Point(0, 0, 0);
      const max = new marietta.core.Point(0, 0, 0);
      gai.GetPolygonMinMax(min, max);
      const ent = this.GetEntrance(); /* 玄関 */
      if (ent != null) {
        for (let i = 0; i < ent.points.length; i += 1) {
          const ln = ent.points.CopyLine(i);
          const mid = ln.GetMidPoint();
          if (gai.IsInclude(mid) === marietta3d.AutoGen.utils.RC_INCLUDE.ONLINE) {
            /* 玄関の辺かつ外周と重なる */
            const fit = this.autoBase.GetOnlineTategu(1, ln.s, ln.e);
            if (fit !== null) {
              /* 建具が配置されている */
              this.MaguchiSub(ent, ln, min, max);
              return;
            }
          }
        }
        /* 建具が見つからない */
        for (let i = 0; i < ent.points.length; i += 1) {
          const ln = ent.points.CopyLine(i);
          const mid = ln.GetMidPoint();
          if (gai.IsInclude(mid) === marietta3d.AutoGen.utils.RC_INCLUDE.ONLINE) {
            /* 玄関の辺かつ外周と重なる */
            this.MaguchiSub(ent, ln, min, max);
            return;
          }
        }
      }
      /* 玄関がない、もしくは玄関の辺が外周に接していない */
      const pitch = this.autoBase.scaleObj.GetModulePitch();
      const module = this.autoBase.scaleObj.GetModule();
      this.autoBase.maguchi = ((max.x - min.x) / pitch) * module;
      this.autoBase.okuyuki = ((max.y - min.y) / pitch) * module;
      this.autoBase.planSizeX = this.autoBase.maguchi;
      this.autoBase.planSizeY = this.autoBase.okuyuki;
    }

    /*------------------------------------------------------
    * 間口奥行サブ
    *
    */
    private MaguchiSub(ent: marietta3d.AutoGen.object.AutoObjRoom, ln: marietta3d.AutoGen.utils.RoomEdge, min: marietta.core.Point, max: marietta.core.Point) {
      const ce = ln.GetMidPoint();
      ln.GetOffsetEdge(5);
      const kce = ln.GetMidPoint();
      if (ent.points.IsInclude(kce) === marietta3d.AutoGen.utils.RC_INCLUDE.INSIDE) {
        ln.GetOffsetEdge(-10);
      }
      const wce = ln.GetMidPoint();
      if (ce.y > wce.y) {
        this.autoBase.genkanhoko = 3;/* 南 */
      } else if (ce.y < wce.y) {
        this.autoBase.genkanhoko = 4;/* 北 */
      } else if (ce.x > wce.x) {
        this.autoBase.genkanhoko = 2;/* 西 */
      } else if (ce.x < wce.x) {
        this.autoBase.genkanhoko = 1;/* 東 */
      }
      const pitch = this.autoBase.scaleObj.GetModulePitch();
      const module = this.autoBase.scaleObj.GetModule();
      if (this.autoBase.genkanhoko === 3 || this.autoBase.genkanhoko === 4) {
        this.autoBase.maguchi = ((max.x - min.x) / pitch) * module;
        this.autoBase.okuyuki = ((max.y - min.y) / pitch) * module;
        this.autoBase.planSizeX = this.autoBase.maguchi;
        this.autoBase.planSizeY = this.autoBase.okuyuki;
      } else {
        this.autoBase.okuyuki = ((max.x - min.x) / pitch) * module;
        this.autoBase.maguchi = ((max.y - min.y) / pitch) * module;
        this.autoBase.planSizeX = this.autoBase.okuyuki;
        this.autoBase.planSizeY = this.autoBase.maguchi;
      }
    }
}
